import React from 'react';
import PropTypes from 'prop-types';
import { Box, ButtonBase, Typography } from '@mui/material';
import {
  ArticleOutlined as ArticleIcon,
  AutoAwesomeOutlined as SmartScoreIcon,
  InsightsOutlined as PerformanceIcon
} from '@mui/icons-material';

const ArticleModalSectionTabs = ({ active, onPerformance, onPublication, onSmartScore }) => {
  const items = [
    { id: 'publication', label: 'Publicação', icon: ArticleIcon, onClick: onPublication },
    { id: 'smartscore', label: 'SmartScore', icon: SmartScoreIcon, onClick: onSmartScore },
    { id: 'performance', label: 'Performance', icon: PerformanceIcon, onClick: onPerformance }
  ];

  return (
    <Box
      role="tablist"
      aria-label="Seções da publicação"
      sx={{
        display: { xs: 'grid', md: 'none' },
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: 0.5,
        p: 0.5,
        mb: 1.5,
        bgcolor: 'action.hover',
        borderRadius: 2
      }}
    >
      {items.map(({ id, label, icon: Icon, onClick }) => {
        const selected = active === id;
        return (
          <ButtonBase
            key={id}
            role="tab"
            aria-selected={selected}
            onClick={onClick}
            sx={{
              minHeight: 40,
              borderRadius: 1.5,
              gap: 0.5,
              bgcolor: selected ? 'background.paper' : 'transparent',
              color: selected ? 'text.primary' : 'text.secondary',
              boxShadow: selected ? '0 1px 4px rgba(0,0,0,0.16)' : 'none'
            }}
          >
            <Icon sx={{ fontSize: 16 }} />
            <Typography noWrap sx={{ fontSize: '0.7rem', fontWeight: selected ? 800 : 650 }}>
              {label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
};

ArticleModalSectionTabs.propTypes = {
  active: PropTypes.oneOf(['publication', 'smartscore', 'performance']).isRequired,
  onPerformance: PropTypes.func.isRequired,
  onPublication: PropTypes.func.isRequired,
  onSmartScore: PropTypes.func.isRequired
};

export default ArticleModalSectionTabs;
